// extracted by mini-css-extract-plugin
module.exports = {"header":"header_header__y29co","wrapper":"header_wrapper__mbs0k","header--navigation":"header_header--navigation__duoUl"};